import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import { GetBannerResponseModel } from '../../../api-models/responses/banner/GetBannerResponseModel';

/**
 دوره ها 
 */
@Injectable({
  providedIn: 'root'
})
export class GetMainFreeCourseService {
  constructor(private baseClient: BaseHttpClientService) {
  }

  call(professorId, pageNum, PageSize, isFree) {
    return this.baseClient.get<any>(
      `/api/v1/Course/get_courses?professorId=${professorId}&pageNumber=${pageNum}&pageSize=${PageSize}&isFree=${isFree}`
    );
  }
}
